import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';

export default function TheComp() {
    const { t } = useLang('rapid.StickyC');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${css.comp}`,
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    });

    return (
        <div className={css.comp}>
            <div className="sticky-box">
                <div className={`img-box ${enter ? 'enter' : ''}`}>
                    <EfImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1729591466898/pc_part03.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1729591466709/m_part03.jpg'}
                    />
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <p className="label">{t('label')}</p>
                        <p className="title">
                            {t.rich('title', {
                                sup: (text: string) => <sup className="sup">{text}</sup>,
                            })}
                        </p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
